import http from "../http-common";
const baseSlug = "/users";

class userService {
  getAll() {
    return http.get(`${baseSlug}`);
  }
  

  get(id) {
    return http.get(`${baseSlug}/${id}`);
  }

  getProjectsByEmail(email){
    return http.get(`${baseSlug}/getProjectsByEmail/${email}`);
  }

  profile() {
    return http.get(`${baseSlug}/profile`);
  }

  logout() {
    return http.get(`${baseSlug}/logout`);
  }

  create(data) {
    return http.post(`${baseSlug}/create`, data);
  }

  update(userid, data) {
    return http.put(`${baseSlug}/update/${userid}`, data);
  }

  delete(id) {
    return http.delete(`${baseSlug}/${id}`);
  }

  login(data) {
    return http.post(`${baseSlug}/login`, data);
  }

  validateSsoUser(data) {
    return http.post(`${baseSlug}/validateSsoUser`, data);
  }
}

export default new userService();
